/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { ElSharedModule } from '../shared/shared.module';
import { ElSpinnerComponent } from './spinner.component';
import { ElSpinnerDirective } from './spinner.directive';


@NgModule({
  imports: [
    ElSharedModule,
  ],
  exports: [ElSpinnerComponent, ElSpinnerDirective],
  declarations: [ElSpinnerComponent, ElSpinnerDirective],
  entryComponents: [ElSpinnerComponent],
})
export class ElSpinnerModule {}
